module.exports = __webpack_public_path__ + "img/compact.d9b1f531.png";